<li class="list-group-item border">
  <div data-toggle="tooltip" title="{{dependentItem().DependentItemName}}">
    <div style="display:inline-block; width:55%;">
      <span style="width:100%; display:inline-block; white-space:nowrap; overflow:clip; text-overflow:ellipsis;"> {{dependentItem().DependentItemName}} </span>
    </div>
    <div style="display: inline-block; width:10%;">
      <kendo-numerictextbox style="width:100%" [min]="0" [value]="dependentItem().Quantity" format="#" (valueChange)="onChange($event)"
        [decimals]="0" [placeholder]="'Qty'" [spinners]="false">
      </kendo-numerictextbox>
    </div>
    <div style="display: inline-block; width:25%;">
      <kendo-combobox style="width:100%" [data]="projectSubTypes" [textField]="'Description'" [valueField]="'ProjectSubTypeId'" (valueChange)="onChange($event)"
        [(ngModel)]="selectedProjectSubType" [placeholder]="'Project Sub Type'" [clearButton]="false">
      </kendo-combobox>
    </div>
    <div style="display: inline-block; width:5%;">
      <button type="button" kendoButton class="ms-1" [svgIcon]="icons.close" (click)="removeWell(dependentItem()); $event.stopPropagation()"></button>
    </div>
  </div>
</li>